import { defineMessages } from "react-intl";

export const messages = defineMessages({
  emptyText: {
    defaultMessage: "No orders found",
    id: "RlfqSV",
  },
});

export const columnsMessages = defineMessages({
  number: {
    defaultMessage: "Number",
    id: "kFkPWB",
  },
  date: {
    id: "mCP0UD",
    defaultMessage: "Date",
    description: "order draft creation date",
  },
  customer: {
    id: "hkENym",
    defaultMessage: "Customer",
  },
  total: {
    id: "1Uj0Wd",
    defaultMessage: "Total",
    description: "order draft total price",
  },
  channel: {
    id: "RgdgqJ",
    defaultMessage: "Channel",
    description: "order draft channel name",
  },
});
